<template>
    <overlay :visible="visible" @close="$emit('close')">
        <popup @close="$emit('close')" :title="$t('CBCX_TICKETS__TICKET_DETAILS')">
            <div class="additional-info" v-if="basicInfo && details">
                <div class="info">
                    {{$t('CBCX_TICKETS__CREATE_DATE') + ' - ' + getTime(details.receiveTimestamp)}}
                </div>
                <div class="info">
                    {{$t('CBCX_TICKETS__BET_AMOUNT') + ' - ' + basicInfo.betAmount + ' ' + basicInfo.currencyCode}}
                </div>
                <div class="info">
                    {{$t('CBCX_TICKETS__POSSIBLE_WIN') + ' - ' + details.maxPossibleWinnings + ' ' + basicInfo.currencyCode}}
                </div>
                <div class="info">
                    {{$t('CBCX_TICKETS__TOTAL_ODD') + ' - ' + details.totalOdd}}
                </div>
                <div class="info">
                    {{$t('CBCX_TICKETS__TYPE') + ' - ' + details.betTypeInfo.betType.value}}
                </div>
                <div class="info">
                    <span>{{ $t('CBCX_TICKETS__STATUS') }}</span>
                    <span>&nbsp;-&nbsp;</span>
                    <span :class="{'won-tip': details.currentTicketState.calculationState.type == 'WON', 'lost-tip': details.currentTicketState.calculationState.type == 'LOST'}">
                        {{ details.currentTicketState.calculationState.value }}
                    </span>
                </div>
            </div>
            <grid 
                :fullGrid="true"
                :passedData="details ? details.tips : []"
                identificator="id"
                :columns="columns"
                :pagination=false
            />
        </popup>
    </overlay>
</template>

<script>
import Overlay from '@/components/ReusableComponents/Overlay/Overlay.vue'
import Popup from '@/components/ReusableComponents/Popup/Popup.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import { addHours, getDateString } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        Overlay,
        Popup,
        Grid,
    },
    props: {
        basicInfo: Object,
        details: Object,
        visible: Boolean,
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t('CBCX_TICKETS__DATE'),
                    key: '',
                    customTemplate: (item) => getDateString(addHours(item.match.startTimestamp, 2), 'yyyy-MM-dd HH:mm')
                },
                {
                    title: this.$t('CBCX_TICKETS__MATCH'),
                    key: '',
                    customTemplate: (item) => {
                        let title = item.match.teams.team1 + ' - ' + item.match.teams.team2
                        let description = item.match.sport
                        if(item.match.category) description += `, ${item.match.category}`
                        if(item.match.tournament) description += `, ${item.match.tournament}`
                        return `<div class="match-description">
                            <div class="match-title">${title}</div>
                            <div class="description">${description}</div>
                        </div>`
                    },
                },
                {
                    title: this.$t('CBCX_TICKETS__RESULT'),
                    key: 'market',
                    customTemplate: (item) => {
                        return `<div class="match-result">
                            <div class="match-market">${item.market}</div>
                            <div class="match-pick">Pick: ${item.option}</div>
                        </div>`
                    },
                },
                {
                    title: this.$t('CBCX_TICKETS__ODD'),
                    key: 'oddValue',
                },
                {
                    title: this.$t('CBCX_TICKETS__STATUS'),
                    key: '',
                    customTemplate: (item) => {
                        switch(item.currentTipState.calculationState.type) {
                            case 'LOST':
                                return `<div class="lost-tip">${this.$t('CBCX_TICKETS__LOSE')}</div>`
                            case 'WON':
                                return `<div class="won-tip">${this.$t('CBCX_TICKETS__WIN')}</div>`
                        }
                    }
                }
            ],
        }
    },
    methods: {
        getTime(timestamp) {
            return getDateString(addHours(timestamp, 2), 'yyyy-MM-dd HH:mm')
        }
    }
}
</script>

<style scoped lang="scss">
.additional-info {
    margin-bottom: 15 * $rem;
    background-color: #fff;
    border: $rem solid #e3e4eb;
    border-radius: 5 * $rem;
    font-size: 15 * $rem;
    display: flex;
    flex-wrap: wrap;
    color: #707070;
    font-weight: 500;

    .info {
        padding: 15 * $rem 10 * $rem;
        border-right: $rem solid #e3e4eb;
        width: calc(100% / 6);
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        &:last-child {
            border-right: none;
        }
    }
}

@media only screen and (max-width: 950px) {
    /deep/ .popup {
        width: 90vw !important;

        .additional-info .info {
            width: calc(100% / 3);
            border-bottom: $rem solid #e3e4eb;
        }
    }
}

@media only screen and (max-width: 750px) {
    /deep/ .popup {
        width: 90vw !important;

        .additional-info .info {
            width: 50%;
            border-bottom: $rem solid #e3e4eb;
        }
    }
}

@media only screen and (max-width: 500px) {
    /deep/ .popup {
        .additional-info .info {
            width: 100%;
        }
    }
}

/deep/ .popup {
    width: 80vw;
}

/deep/ .match-description {
    .match-title {
        font-weight: 500;
        font-size: 15 * $rem;
        color: rgb(31, 31, 31);
        margin-bottom: 5 * $rem;
        white-space: normal;
    }

    .description {
        white-space: normal;
    }
}

/deep/ .match-result {
    .match-market {
        font-weight: 500;
        color: rgb(31, 31, 31);
        margin-bottom: 5 * $rem;
        white-space: normal;
    }
}

/deep/ .lost-tip {
    color: $red;
}

/deep/ .won-tip {
    color: $green-main;
}
</style>